
define('text!common/views/commercial/plista.html',[],function () { return '<div class="PLISTA" data-ob-template="guardian">\n    <div data-display="plista_widget_<%=widgetName%>"></div>\n</div>\n';});

